import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const CompareByDate = ({
  handleClose,
  handleDateChange,
  selectedDate,
  setSelectedDate,
  date1DayAgo,
  sixMonthsAgo,
}) => {
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={true}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={true}>
          <Box className="select-date-box">
            <Typography variant="h6" gutterBottom>
              Compare by Dates
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]}>
                <DatePicker
                  label="From"
                  value={selectedDate?.from}
                  minDate={sixMonthsAgo} // Min date: 6 months before today
                  maxDate={selectedDate.to.subtract(1, "day")}
                  onChange={(date) => {
                    setSelectedDate((pre) => ({
                      ...pre,
                      from: date,
                    }));
                  }}
                />
                <DatePicker
                  label="To"
                  value={selectedDate.to}
                  minDate={selectedDate.from} // Min date: same as "From" date
                  maxDate={date1DayAgo}
                  onChange={(date) => {
                    setSelectedDate((pre) => ({
                      ...pre,
                      to: date,
                    }));
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <Box className="d-flex align-items-end">
              <Button
                variant="contained"
                onClick={() => handleDateChange()}
                className="mt-3 ms-auto"
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default CompareByDate;
